export const PERSONAL_USE_FIELDS = [  
  { key: "cost", label: "cost" },
  { key: "description", label: "description", type: 'textarea' },
]

export const PERSONAL_USE_REQUIRED_FIELDS = [
  { key: "date", label: "date", type: 'date' },
  { key: "kilometers", label: "kilometers", type: 'number' },
];

export const FIELDS = [...PERSONAL_USE_REQUIRED_FIELDS, ...PERSONAL_USE_FIELDS]
